import { render } from "./arrow-double-horizontal.vue?vue&type=template&id=438dfaac"
import script from "./arrow-double-horizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./arrow-double-horizontal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/ui-components/src/components/icons/arrow-double-horizontal/arrow-double-horizontal.vue"]])

export default __exports__